import { INotificationPreference } from "../interfaces/notification-preference";
import { INotificationsState } from "../interfaces/notifications-state";

export const notificationsInitState: INotificationsState = {
    channels: [],
    events: [],
    currentPreference: {} as INotificationPreference,
    currentPreferenceLoading: false,
};
